module.exports = __webpack_public_path__ + "static/media/blocked-players-icon.eadfcb45.svg";